export enum DocumentsStatus {
  ADMIN = 'ADMIN',
  EXECUTION = 'EXECUTION',
  ISSUE = 'ISSUE',
}

export namespace DocumentsStatus {
  export const tabs = [undefined, DocumentsStatus.EXECUTION, DocumentsStatus.ISSUE];
}